import React from 'react'
import styled from 'styled-components'

const Center = styled.h5`
	font-size: 12px;
	text-align: center;
`;

const PageCredits = (props)=> {
	return(
		<Center>
			Research and writing by<br/>{props.attributions}
		</Center>
	);
}

export default PageCredits;


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/PageCredits.js